import { FC } from 'react';
import { UserOutlined, MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
import { Layout, Button, Popover } from 'antd';
import { Avatar } from 'antd';
import { Col, Row } from 'antd';
import "./styles.css";
import { getUser, removeTokens } from '../../services/localStorage';
import { useNavigate } from 'react-router-dom';
const { Header } = Layout;

interface HeaderProps {
  collapsed: boolean;
  toggle: () => void;
}

const HeaderComponent: FC<HeaderProps> = ({ collapsed, toggle }) => {
  let navigate = useNavigate();
  const currentUser = JSON.parse(getUser() || '{}');
  const logout = () => {
    removeTokens();
    navigate('/login');
  }

  const content = (
    <div>
      <h3 className='sub_data'>{currentUser?.user_name} ({currentUser?.user_sgid})</h3>
      <p className='sub_data'>{currentUser?.user_email} <br></br>{currentUser?.user_role}</p>
      <Button type="link" onClick={logout} style={{ padding: '0px' }}>Sign Out</Button>
    </div>
  );

  return (
    <Header className='header' style={{ backgroundColor: "#018B98" }}>
      <Row justify="space-between">
        <Col span={2}>
          <div className="div_float" onClick={toggle}>
            <span className='sidebar_span' id="sidebar-trigger">{collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}</span>
          </div>
        </Col>
        <Col span={2}></Col>

        <Col span={8}>
          <div className='mid_col'>
            <Avatar shape='square' style={{ height: '40px', width: '40px' }} src="./furon.png" />
            <span style={{ color: 'white', paddingLeft: '10px' }}>Furon Fitting Configurator BackOffice</span>
          </div>
        </Col>

        <Col span={4}>
          <div style={{ float: 'right' }}>

            <Popover placement="bottomRight" title="" content={content} trigger="hover">
              <span className="user-action">
                <Avatar size="large" shape='square' icon={<UserOutlined />} />
              </span>
            </Popover>
          </div>
        </Col>
      </Row>
    </Header>
  );
};

export default HeaderComponent;